<ng-container
  [ngTemplateOutlet]="
    template === 'displayRules' ? serviceBuilderDisplayRules : default
  "></ng-container>

<ng-template #default>
  <div class="mb-3 irembogov-custom-repeater" [attr.data-field-id]="field.id">
    <div
      *ngFor="let fieldItem of field.fieldGroup; let i = index"
      class="d-flex custom-repeater-extra-fields">
      <formly-field
        class="repeater-group repeater-extra-fields flex-grow-1 text-truncate"
        [field]="fieldItem"></formly-field>
      <ng-container *ngIf="!field?.props?.readonly">
        <button
          class="btn btn-danger ms-2 repeater-add-button flex-shrink-0"
          [disabled]="field.props.disabled"
          type="button"
          (click)="removeItem(i)">
          <i class="fa-solid fa-trash-can"></i></button
      ></ng-container>
    </div>
    <div class="my-1" *ngIf="!field?.props?.readonly">
      <button
        [disabled]="field.props.disabled || checkIfMaxLengthLimitReached()"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="add()">
        <i class="fa-solid fa-plus"></i> {{ props['addText'] ?? 'Add' }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #serviceBuilderDisplayRules>
  <div class="sb-irembogov-custom-repeater">
    <div
      *ngFor="let fieldItem of field.fieldGroup; let i = index"
      class="d-flex custom-repeater-extra-fields service-builder-styles">
      <div class="title">
        <h1>{{ field.props['title'] }} {{ i + 1 }}</h1>
        <button
          [disabled]="field.props.disabled"
          type="button"
          (click)="removeItem(i)">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>

      <div class="field-container">
        <formly-field
          class="repeater-group repeater-extra-fields flex-grow-1 text-truncate"
          [field]="fieldItem"></formly-field>
      </div>
    </div>
    <div class="my-1 mt-3">
      <button
        [disabled]="field.props.disabled || checkIfMaxLengthLimitReached()"
        class="btn btn-primary btn-sm w-100"
        type="button"
        (click)="add()">
        <i class="fa-solid fa-plus"></i> {{ props['addText'] ?? 'Add' }}
      </button>
    </div>
  </div>
</ng-template>
